const wishbasket = {
    id: 'wishbasket',
    publicSiteName: 'Wish Basket',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    ageVerifiedPopup:'no',
    theme: {
        colors: {
            primary: '#F90217',
            secondary: '#323231',
            color1: '#F8BA0B',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/wishbasket/favicon.ico',
        logo: '/wishbasket/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default wishbasket